import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Route } from 'react-router-dom'
import MenuItem from '@material-ui/core/MenuItem'
import ListItemText from '@material-ui/core/ListItemText'
import { translate as translateComponent } from 'react-admin'
import { nanoid } from 'nanoid'
import { getUser } from '../../../../user'

const EpiFormButton = ({ className, record, translate }) => {
  const user = getUser()

  const today = new Date()

  const year = new Intl.DateTimeFormat('fr', { year: 'numeric' }).format(today)
  const month = new Intl.DateTimeFormat('fr', { month: 'long' }).format(today)
  const day = new Intl.DateTimeFormat('fr', { day: '2-digit' }).format(today)

  const todayString = `${day} ${month} ${year}`

  const address = `${record?.mailing_street} ${record?.mailing_city} ${record?.mailing_postal_code}`

  const id = nanoid(18)

  const formUrl = 'https://forms.cleany.fr/remise-epi'

  const params =
    `?formId=${id}` +
    `&employeeSilaeId=${record?.silae_id}` +
    `&todayDate=${todayString}` +
    `&employeeFullname=${record?.fullname}` +
    `&employeeAddress=${address}` +
    `&issuerFullname=${user?.fullname}`

  return (
    <Fragment>
      <Route
        render={() => {
          return (
            <MenuItem
              className={className}
              variant="contained"
              onClick={() => {
                window.open(`${formUrl}${params}`)
              }}
            >
              <ListItemText primary="Formulaire de remise d'EPI" />
            </MenuItem>
          )
        }}
      />
    </Fragment>
  )
}

EpiFormButton.propTypes = {
  className: PropTypes.string,
  record: PropTypes.object,
  translate: PropTypes.func,
}

EpiFormButton.defaultProps = {
  className: undefined,
  record: undefined,
  translate: () => {},
}

export default translateComponent(EpiFormButton)